var map = {
	"./Framabag.vue": 103,
	"./Framabee.vue": 101,
	"./Framabin.vue": 104,
	"./Framaboard.vue": 105,
	"./Framabookin.vue": 106,
	"./Framacalc.vue": 107,
	"./Framaclic.vue": 108,
	"./Framadrop.vue": 109,
	"./Framaestro.vue": 110,
	"./Framalink.vue": 111,
	"./Framanews.vue": 112,
	"./Framanotes.vue": 113,
	"./Framapic.vue": 114,
	"./Framasite.vue": 115,
	"./Framaslides.vue": 116,
	"./Framasphere.vue": 117,
	"./Framastory.vue": 118,
	"./Framavectoriel.vue": 119,
	"./Framawiki.vue": 120,
	"./Framemo.vue": 121,
	"./Framindmap.vue": 122,
	"./Home.vue": 102,
	"./Myframa.vue": 123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;